import { useState } from "react";
import { Button } from "../Button";
import {
  Sheet,
  SheetBar,
  SheetClose,
  SheetContent,
  SheetTrigger,
} from "../Sheet";

export const DemoMode = () => {
  const [open, setOpen] = useState(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger>
        <div
          className="flex justify-center items-center gap-2 px-3 py-2 rounded-full bg-white/20 text-size-16 text-inverted"
          onClick={() => setOpen(true)}
        >
          Demo Mode
          <img src="/img/icon/info.svg" />
        </div>
      </SheetTrigger>

      <SheetContent className="flex flex-col items-center gap-5">
        <SheetBar />
        <div className="text-size-32 font-medium">You’re in demo mode.</div>
        <div className="text-size-16 text-muted text-center">
          Feel free to explore and get familiar with how it works.
        </div>
        <SheetClose className="w-full">
          <Button onClick={() => setOpen(false)}>Try it out</Button>
        </SheetClose>
      </SheetContent>
    </Sheet>
  );
};
